/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiVat, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of VatController.
 */
export class VatRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /vat/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiVat>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiVat>>(`/vat/${primaryId}`, query);
    }

    /**
     * Calls POST /vat:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiVat>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVat>>, ListRequestWithIds>('/vat:batch', listRequest, query);
    }

    /**
     * Calls POST /vat:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiVat>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVat>>, ListRequest>('/vat:query', listRequest, query);
    }

    /**
     * Calls POST /vat
     */
    public add(dto: ApiVat): Promise<Result<ApiVat>> {
        return this.http.post<Result<ApiVat>, ApiVat>('/vat', dto);
    }

    /**
     * Calls PUT /vat/{primaryId}
     */
    public update(dto: ApiVat, primaryId: string): Promise<Result<ApiVat>> {
        return this.http.put<Result<ApiVat>, ApiVat>(`/vat/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /vat
     */
    public putRange(dtos: ApiVat[]): Promise<Result<ApiVat[]>> {
        return this.http.patch<Result<ApiVat[]>, ApiVat[]>('/vat', dtos);
    }

    /**
     * Calls DELETE /vat/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vat/${primaryId}`);
    }

    /**
     * Calls POST /vat/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiVat>> {
        return this.http.post<Result<ApiVat>, undefined>(`/vat/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /vat:prefill
     */
    public createPrefilled(): Promise<Result<ApiVat>> {
        return this.http.post<Result<ApiVat>, undefined>('/vat:prefill', undefined);
    }

    /**
     * Calls POST /vat/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiVat>>> {
        return this.http.post<Result<LockedContextDto<ApiVat>>, undefined>(`/vat/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /vat/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiVat[]>> {
        return this.http.post<Result<ApiVat[]>, string[]>('/vat/locks', ids);
    }

    /**
     * Calls POST /vat/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/vat/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /vat/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vat/${primaryId}/locks`);
    }

    /**
     * Calls GET /vat:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiVat>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiVat>>>('/vat:query', query);
    }
}
